import * as React from "react";
import { Alert } from "@trussworks/react-uswds";
import { Typography } from "@mui/material";
import { fetchData } from "../services/ApiClient";
import { ApiBaseUrl } from "../../config";
import { KeyStringValue } from "../../interfaces";

interface Props {
  updateBanner: (banner: string) => void;
}

export default function CloudFoundryBanner({ updateBanner }: Props) {
  const [bannerState, setBannerState] = React.useState<KeyStringValue[]>([
    { is_active: "", title: "", description: "" },
  ]);

  React.useEffect(() => {
    let isMounted = true;
    (async () => {
      await fetchData(`${ApiBaseUrl()}/maintenance`)
        .then(response => {
          if (isMounted) {
            setBannerState(response.data);
            updateBanner(response.data[0].is_active);
          }
        })
        .catch((error: Error) => {
          console.error(error);
        });
    })();
    return () => {
      isMounted = false;
    };
  }, [updateBanner]);

  return bannerState && bannerState[0]?.is_active === "true" ? (
    <Alert type={"info"} headingLevel="h4" style={{ marginBottom: 16 }}>
      <Typography
        style={{
          fontFamily: "Source Sans Pro",
          fontSize: 24,
          lineHeight: ".9",
          marginTop: 0,
          marginBottom: " 0.5rem",
          fontWeight: "bold",
          marginLeft: 50,
        }}
      >
        {bannerState[0]?.title}
      </Typography>
      <Typography
        style={{
          font: "Source Sans Pro ",
          fontSize: 16,
          paddingBottom: 0,
          marginLeft: 50,
        }}
      >
        {bannerState[0]?.description}
      </Typography>
    </Alert>
  ) : null;
}
